import React from "react";
import { motion } from "framer-motion";
import NavBar from "./nav-bar/nav-bar";
import ProjectGallery from "../sections/projects/project-gallery";
import ProjectGalleryMobile from "../sections/projects/project-gallery-mobile";
import VideoGallery from "./VideoGallery";
import { ANIMATION_TIMING, EASING_CURVES } from "../utils/motion";
import NavBarMobile from "./nav-bar/nav-bar-mobile";
import CustomFooter from "./CustomFooter";
import CustomFooterMobile from "./CustomFooter-mobile";

const Gallery = ({ textes, screenSize, videosProps }) => {

  return (
    <div className="min-h-screen bg-white" onLoad={() => window.scrollTo(0, 0)}>
      {/* Navigation */}
      {screenSize >= 800 ? 
        <NavBar textes={textes} isBackgroundWhite={true} initVisible />
      : (
        <NavBarMobile textes={textes} isBackgroundWhite={true} />
      )}
      {/* Video Gallery Section */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          duration: ANIMATION_TIMING.durations.slow,
          delay: 0.5,
          ease: EASING_CURVES.smooth,
        }}
      >
        <VideoGallery videosProps={videosProps} />
      </motion.div>

      {/* Project Gallery Section */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          duration: ANIMATION_TIMING.durations.slow,
          delay: 0.4,
          ease: EASING_CURVES.smooth,
        }}
      >
        {screenSize >= 768 ? (
          <ProjectGallery minimified={true} />
        ) : (
          <ProjectGalleryMobile minimified={true} />
        )}
      </motion.div>

      {/* Footer spacing */}
      <motion.div
        className="h-32"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{
          duration: ANIMATION_TIMING.durations.normal,
          delay: 0.5,
          ease: EASING_CURVES.smooth,
        }}
      />
      {/* Custom Footer */}
      {screenSize < 768 ? (
        <CustomFooterMobile textes={textes} isBackgroundWhite={true} />
      ) : (
        <CustomFooter textes={textes} isBackgroundWhite={true} />
      )}
    </div>
  );
};

export default Gallery;
